exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modification-select[data-v-2da69ad4] .v-select__selection--comma{margin-top:0!important;font-size:14px!important}a.policy[data-v-2da69ad4]{color:#00ba57}a.policy-disabled[data-v-2da69ad4]{color:#858585}.checkbox-plate[data-v-2da69ad4] .v-input__control{height:25px}.hide-vin-field[data-v-2da69ad4]{display:none}.pts-help-text[data-v-2da69ad4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2da69ad4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/fields/Transport.vue
// module id = hEJp
// module chunks = 0 1